import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

import { CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";

import { WEB_VERIFY_ICP_STRING } from "./common/MetaSetting";

const container = document.getElementById("root")!;
const root = createRoot(container);

const verifyContainer = document.getElementById("verify")!;

import Home from "./home/Home";

import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// 导入翻译资源
import zhCNTranslation from "./assets/locales/zh-CN/translation.json";
import enUSTranslation from "./assets/locales/en-US/translation.json";



// 立即渲染应用，不等待i18n初始化
root.render(
  <React.Fragment>
    <CssBaseline />
    <BrowserRouter>
      <Provider store={store}>
        <Home />
      </Provider>
    </BrowserRouter>
  </React.Fragment>
);

// 异步初始化i18n
i18next
  .use(initReactI18next)
  .init({
    lng: "zh-CN",
    fallbackLng: "zh-CN",
    debug: true,
    resources: {
      "zh-CN": {
        translation: zhCNTranslation
      },
      "en-US": {
        translation: enUSTranslation
      }
    },
    interpolation: {
      escapeValue: false,
    }
  })
  .then(() => {
    // i18n初始化成功
  })
  .catch((error) => {
    console.error("i18n初始化失败:", error);
  });


verifyContainer.innerHTML = `<a href="https://beian.miit.gov.cn/" target="_blank" hidden>${WEB_VERIFY_ICP_STRING}</a>`;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
